import { Component, OnInit } from '@angular/core';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faUser} from '@fortawesome/free-solid-svg-icons';
import { HttpService } from '../http.service';
import { Proflie } from '../profile';
import { ApiService } from '../../app/user/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  faHome = faHome;
  faBars = faBars;
  faUser = faUser;
  allItems: Proflie[];
  loginbtn:boolean;
  logoutbtn:boolean;

  constructor(private _http: HttpService,
    private userApi: ApiService,
    private router:Router) { 
      userApi.getLoggedInName.subscribe(name => this.changeName(name));
      if(this.userApi.isLoggedIn())
      {
        this.loginbtn=false;
        this.logoutbtn=true;
      }
      else{
        this.loginbtn=true;
        this.logoutbtn=false;
      }
    }

  private changeName(name: boolean): void {
    this.logoutbtn = name;
    this.loginbtn = !name;
  }
  logout()
  {
    this.userApi.deleteToken();
    const redirect = this.userApi.redirectUrl ? this.userApi.redirectUrl : '/';
    window.location.href = redirect;
    this.router.navigate([redirect]);
  }

  ngOnInit(): void {

    this._http.getPosts().subscribe(posts => {
      this.allItems = posts;
      this._http.postsData = posts;
      // console.log(this.allItems);
    });

  }

  onSelectedFilter(e) {
    this.getFilteredExpenseList();
  }

  getFilteredExpenseList() {
    if (this._http.searchOption.length > 0)
      this.allItems = this._http.filteredListOptions();
    else {
      this.allItems = this._http.postsData;
    }

  }

  menus = [
    {title:'Home',link: '/home'},
    {title:'Web',link: '/web'},
    {title:'Photography',link: '/photography'},
    {title:'Contact',link: '/contact'},
  ]

}
